import Api from '../api'

let api = new Api()

class EventsSection {
  dependencies = {}

  constructor(dependencies) {
    this.dependencies = dependencies
  }

  async recalculatePoAndReturnIt(PO, settings, isP2PInvoiceWithEditItem) {
    // set category name
    PO.events.map(ev => {
      ev.lineItems.map(item => {
        if (item.category && !item.isFeeDiscountItem && typeof item.category === 'object') {
          item.category = item.category.name || item.category.text || item.category.label || ''
        }
        return item
      })
    })

    let poComputeTotalsUrl = this.dependencies.useSavingsFields
      ? api.SavingsPurchaseOrderComputeTotals()
      : api.PurchaseOrderComputeTotals()

    let response = await this.dependencies.api.post(
      poComputeTotalsUrl,
      {
        Data: PO,
        UserId: this.dependencies.loggedInUserID
      }
    )

    if (response && response.data) {
      PO.total = response.data.total
      PO.subtotal = response.data.subtotal
      PO.fees = response.data.fees
      PO.taxes = response.data.taxes
      PO.balance = response.data.balance
      PO.discounts = response.data.discounts
      PO.vat = response.data.vat
      PO.gst = response.data.gst

      let poTotalTaxesAndFees = 0

      for (let responseEvent of response.data.events) {
        let poEvent = PO.events.filter(
          x => x.uniqueId === responseEvent.uniqueId
        )[0]

        if (poEvent) {
          poEvent.total = responseEvent.total
          poEvent.fees = responseEvent.fees
          poEvent.taxes = responseEvent.taxes
          poEvent.vat = responseEvent.vat
          poEvent.gst = responseEvent.gst
          poEvent.discounts = responseEvent.discounts
          poEvent.subtotal = responseEvent.subtotal

          let listOrdersToRemove = poEvent.lineItems
            .filter(itm =>
              itm.isAutoGenerated &&
              responseEvent.lineItems.filter(n => +n.listOrder === +itm.listOrder).length === 0)
            .map(function(itm) { return +itm.listOrder })
          let totalWithTaxesAndFees = 0

          for (let responseItem of responseEvent.lineItems) {
            let poLineItem = poEvent.lineItems.filter(
              x => +x.listOrder === +responseItem.listOrder
            )[0]

            if (poLineItem) {
              poLineItem.total = responseItem.total
              poLineItem.subtotal = responseItem.subtotal
              poLineItem.discountAmount = responseItem.discountAmount
              poLineItem.discountPercent = responseItem.discountPercent
              poLineItem.totalTaxes = responseItem.totalTaxes
              poLineItem.totalFees = responseItem.totalFees
              poLineItem.totalTaxesForFees = responseItem.totalTaxesForFees
              poLineItem.totalWithTaxesAndFees = responseItem.totalWithTaxesAndFees

              poLineItem.fees = responseItem.fees
              poLineItem.taxes = responseItem.taxes

              poLineItem.hasCostCenter = settings.HasCostCenter
              poLineItem.hasBusinessUnit = settings.HasBusinessUnit

              delete poLineItem._pending
              delete poLineItem._loading

              // decoupling: taxes & fees are still displayed when total amount = 0
              if (settings.AllowEditItem && !poLineItem.isAutoGenerated &&
                Number(responseItem.quantity) === 0) {
                poLineItem.totalTaxes = 0
                poLineItem.totalFees = 0
                poLineItem.totalTaxesForFees = 0
                poLineItem.total = 0
                poLineItem.totalWithTaxesAndFees = 0
              }

              if (settings.ExcludeTaxesFromPOThreshold) {
                poLineItem.totalToValidate = Number(poLineItem.total)
              }

              if (!poLineItem.subtotal) {
                totalWithTaxesAndFees += Number(poLineItem.total)
              } else {
                totalWithTaxesAndFees += Number(poLineItem.subtotal) + Number(poLineItem.totalTaxes) + Number(poLineItem.totalFees)
              }
            } else {
              let newItem = utils.copy(responseItem)

              newItem.hasCostCenter = settings.HasCostCenter
              newItem.hasBusinessUnit = settings.HasBusinessUnit

              delete newItem._pending
              delete newItem._loading

              if (settings.AllowEditItem && !newItem.isAutoGenerated &&
                Number(newItem.quantity) === 0) {
                newItem.totalTaxes = 0
                newItem.totalFees = 0
                newItem.totalTaxesForFees = 0
                newItem.total = 0
                newItem.totalWithTaxesAndFees = 0
              }

              if (settings.ExcludeTaxesFromPOThreshold) {
                newItem.totalToValidate = Number(newItem.total)
              }

              if (!newItem.subtotal) {
                totalWithTaxesAndFees += Number(newItem.total)
              } else {
                totalWithTaxesAndFees += Number(newItem.subtotal) + Number(newItem.totalTaxes) + Number(newItem.totalFees)
              }

              newItem.entireRowInvalid = isP2PInvoiceWithEditItem && newItem.isAutoGenerated && newItem.feeTypeId > 0 && !newItem.itemExistsOnPO

              poEvent.lineItems.push(newItem)
            }
          }

          // decoupling: adjust total on event
          if (settings.AllowEditItem) {
            poTotalTaxesAndFees += totalWithTaxesAndFees
            poEvent.total = Math.round(totalWithTaxesAndFees * 100) / 100
          }

          // remove auto generated taxes/fees
          if (!responseEvent.lineItems || responseEvent.lineItems.length === 0) {
            poEvent.lineItems = []
          } else if (listOrdersToRemove && listOrdersToRemove.length > 0) {
            poEvent.lineItems = poEvent.lineItems.filter(itm => !itm.isAutoGenerated ||
              (itm.isAutoGenerated && listOrdersToRemove.indexOf(+itm.listOrder) === -1))
          }

          poEvent.lineItems = this.updateLineItemsOrder(poEvent.lineItems)
        }
      }

      // decoupling: adjust total on PO
      if (settings.AllowEditItem) {
        PO.total = Math.round(poTotalTaxesAndFees * 100) / 100
      }
    } else {
      this.deletePendingLoadingItems(PO)
    }

    return PO
  }

  updateLineItemsOrder(lineItems) {
    lineItems = lineItems.sort((a, b) => +a.listOrder > +b.listOrder ? 1 : (+b.listOrder > +a.listOrder ? -1 : 0))
    let listOrder = 1
    for (let poItem of lineItems) {
      if (+poItem.listOrder !== listOrder) {
        poItem.listOrder = listOrder
      }
      listOrder++
    }
    return lineItems
  }

  deletePendingLoadingItems(PO) {
    PO.events.map(ev => {
      ev.lineItems.map(item => {
        delete item._pending
        delete item._loading
      })
    })
  }

  mapLineItemPropertiesFromSourceToTargetForCreate(targetLineItem, sourceLineItem) {
    targetLineItem.name = sourceLineItem.name
    targetLineItem.description = sourceLineItem.description
    targetLineItem.internalNote = sourceLineItem.internalNote
    targetLineItem.taxCode = sourceLineItem.taxCode
    targetLineItem.category = sourceLineItem.selectedCategory
      ? sourceLineItem.selectedCategory.text
      : ''
    targetLineItem.categoryRefId = sourceLineItem.categoryRefId
    targetLineItem.pairedBusinessUnitAndCostCenter = sourceLineItem.pairedBusinessUnitAndCostCenter
    targetLineItem.costCenterAndBusinessUnit = sourceLineItem.costCenterAndBusinessUnit
    targetLineItem.useBusinessUnitAndCostCenterMapping = sourceLineItem.useBusinessUnitAndCostCenterMapping
    targetLineItem.unit = sourceLineItem.unit
    if (sourceLineItem.unitPriceSGR) {
      targetLineItem.unitPriceSGR = sourceLineItem.unitPriceSGR
      targetLineItem.unitPricePreferredRate = sourceLineItem.unitPricePreferredRate
      targetLineItem.unitPriceNegotiatedRate = sourceLineItem.unitPriceNegotiatedRate
      targetLineItem.totalSGR = sourceLineItem.totalSGR
      targetLineItem.totalPreferredRate = sourceLineItem.totalPreferredRate
      targetLineItem.totalNegotiatedRate = sourceLineItem.totalNegotiatedRate
    } else {
      // TODO
      targetLineItem.unitPriceSGR = 0
      targetLineItem.unitPricePreferredRate = 0
      targetLineItem.unitPriceNegotiatedRate = 0
      targetLineItem.totalSGR = 0
      targetLineItem.totalPreferredRate = 0
      targetLineItem.totalNegotiatedRate = 0
    }
    targetLineItem.unitPrice = sourceLineItem.unitPrice
    targetLineItem.quantity = sourceLineItem.quantity
    targetLineItem.units = sourceLineItem.units
    targetLineItem.subtotal = sourceLineItem.subtotal
    targetLineItem.total = sourceLineItem.total
    targetLineItem.discountAmount = sourceLineItem.discountAmount
    targetLineItem.discountPercent = sourceLineItem.discountPercent
    targetLineItem.totalTaxes = sourceLineItem.totalTaxes
    targetLineItem.totalFees = sourceLineItem.totalFees
    targetLineItem.totalTaxesForFees = sourceLineItem.totalTaxesForFees
    targetLineItem.totalWithTaxesAndFees = sourceLineItem.totalWithTaxesAndFees
    targetLineItem.unitTypeModel = sourceLineItem.unitTypeModel
    targetLineItem.unitType = sourceLineItem.unitType
    targetLineItem.taxes = sourceLineItem.taxes
    targetLineItem.fees = sourceLineItem.fees
    targetLineItem.referenceId = sourceLineItem.referenceId
    targetLineItem.isAutoGenerated = sourceLineItem.isAutoGenerated
    targetLineItem.customFields = sourceLineItem.customFields
    //
    targetLineItem._expanded = sourceLineItem._expanded

    return targetLineItem
  }

  mapLineItemPropertiesFromSourceToTargetForEdit(targetLineItem, sourceLineItem) {
    targetLineItem = this.mapLineItemPropertiesFromSourceToTargetForCreate(targetLineItem, sourceLineItem)

    for (let i = 0; i < targetLineItem.taxes.length; i++) {
      let computedTax = sourceLineItem.taxes.find(function (tax) {
        return tax.name === targetLineItem.taxes[i].name
      })
      if (computedTax) {
        targetLineItem.taxes[i].isChecked = computedTax.isChecked
        targetLineItem.taxes[i].percentage = computedTax.percentage
        targetLineItem.taxes[i].value = computedTax.value
        targetLineItem.taxes[i].totalTaxes = computedTax.totalTaxes
      }
    }

    for (let i = 0; i < targetLineItem.fees.length; i++) {
      let computedFee = sourceLineItem.fees.find(function (fee) {
        return fee.name === targetLineItem.fees[i].name
      })
      if (computedFee) {
        targetLineItem.fees[i].value = computedFee.value
        targetLineItem.fees[i].totalTaxes = computedFee.totalTaxes
      }
    }

    return targetLineItem
  }

  getLineItemListElementFromFeeDiscount(lineItem, sourceFeeDiscount) {
    lineItem.name = sourceFeeDiscount.category.text
    lineItem.pairedBusinessUnitAndCostCenter = sourceFeeDiscount.pairedBusinessUnitAndCostCenter
    lineItem.costCenterAndBusinessUnit = sourceFeeDiscount.costCenterAndBusinessUnit
    lineItem.useBusinessUnitAndCostCenterMapping = sourceFeeDiscount.useBusinessUnitAndCostCenterMapping
    lineItem.costCenter = sourceFeeDiscount.costCenter
    lineItem.businessUnit = sourceFeeDiscount.businessUnit
    lineItem.amountTypeValue = sourceFeeDiscount.amountTypeValue || 0
    lineItem.unitPrice = sourceFeeDiscount.amountTypeValue || 0
    lineItem.amountTypeId = sourceFeeDiscount.amountType.amountType || 0
    lineItem.itemTypeId = sourceFeeDiscount.category.itemType
    lineItem.units = ''
    lineItem.quantity = sourceFeeDiscount.amountTypeValue !== '' ? 1 : ''
    lineItem.isFeeDiscountItem = true
    lineItem.description = sourceFeeDiscount.description
    lineItem.total = sourceFeeDiscount.amountTypeValue || 0
    lineItem.subtotal = sourceFeeDiscount.amountTypeValue || 0
    lineItem.category = ''
    lineItem.feeTypeId = sourceFeeDiscount.feeTypeId
    lineItem.taxTypeId = sourceFeeDiscount.taxTypeId
    lineItem.customTypeId = sourceFeeDiscount.customTypeId
    lineItem.customFields = sourceFeeDiscount.customFields
    return lineItem
  }
}

export default EventsSection



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/EventsSection/EventsSection.js